<template>
  <div>
    <el-dialog
      v-model="store.isShowSoundControlsModal"
      class="settingsModal"
      :class="{ 'ru-locale': $i18n.locale === 'ru' }"
      :title="$t('soundControlsModalTitle')"
      :append-to-body="true"
      :fullscreen="$device.isMobile"
    >
      <div class="settingsTabs">
        <div class="settingTab" :class="{ 'is-active': activeTab === 'sound' }" @click="activeTab = 'sound'">
          {{ $t('sound') }}
        </div>
        <div
          class="settingTab"
          :class="{ 'is-active': activeTab === 'autoConfirm' }"
          @click="activeTab = 'autoConfirm'"
        >
          {{ $t('autoConfirm') }}
        </div>
      </div>
      <UIModalInnerContentWrapper style="background-color: rgba(13, 36, 47, 1); padding-top: 5px" hide-scroll>
        <div v-if="activeTab === 'sound'" style="padding: 15px">
          <GeneralSoundControlItem
            v-for="(item, volumeKey) in store.volume"
            :key="volumeKey"
            v-model="store.volume[volumeKey]"
            :control-name="volumeKey"
          />
        </div>

        <div v-else-if="activeTab === 'autoConfirm'" style="padding: 0 15px 15px 15px">
          <div class="notice">
            <el-checkbox
              id="agree-cb"
              v-model="currentFlags.agreeToCraftingRules"
              type="checkbox"
              class="checkbox"
              size="large"
            >
              <p class="agreetment-title">{{ $t('autoConfirmCraftingTitle') }}</p>
            </el-checkbox>
            <p class="agreetment-text">
              {{ $t('autoConfirmCraftingDescription') }}
            </p>
          </div>
          <div class="notice">
            <el-checkbox
              id="agree-cb"
              v-model="currentFlags.agreeToMiningRules"
              type="checkbox"
              class="checkbox"
              size="large"
            >
              <p class="agreetment-title">{{ $t('autoConfirmMiningTitle') }}</p>
            </el-checkbox>
            <p class="agreetment-text">
              {{ $t('autoConfirmMiningDescription') }}
            </p>
          </div>
          <div class="notice">
            <el-checkbox
              id="agree-cb"
              v-model="currentFlags.agreeToBuyPearlRules"
              type="checkbox"
              class="checkbox"
              size="large"
            >
              <p class="agreetment-title">{{ $t('autoConfirmBuyPearlTitle') }}</p>
            </el-checkbox>
            <p class="agreetment-text">
              {{ $t('autoConfirmBuyPearlDescription') }}
            </p>
          </div>
          <div style="text-align: center">
            <button class="btn-primary" @click="handleAgreeAction">{{ $t('autoConfirmBtn') }}</button>
          </div>
        </div>
      </UIModalInnerContentWrapper>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
const store = useMainStore();

const activeTab = ref<'sound' | 'autoConfirm'>('sound');

const { currentFlags, saveAllFlags } = useAutoConfirmFlags();

const handleAgreeAction = () => {
  saveAllFlags();
  store.isShowSoundControlsModal = false;
};
</script>

<style lang="scss" scoped>
.settingsTabs {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.settingTab {
  height: 40px;
  background: rgba(128, 128, 128, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Grenze, sans-serif;
  font-weight: 600;
  font-size: 24px;
  border-radius: 12px;
  padding: 0 10px;
  cursor: pointer;
  transition: 0.3s ease;
}

.settingTab.is-active {
  background: linear-gradient(to bottom, rgba(0, 131, 173, 1), rgba(0, 53, 79, 1));
}

.placeholder-text {
  color: white;
  text-align: center;
  padding: 20px;
  font-size: 18px;
}

.agreetment-title {
  color: #ffffff;
  font-size: 18px;
  margin-bottom: 8px;
}

.agreetment-text {
  color: #838d92;
  font-size: 14px;
  line-height: 1;
}
</style>
